enum KeyCodes {
    Enter = 13,
    Space = 32,
    Escape = 27,
    Tab = 9,
    Up = 38,
    Down = 40,
}

export default KeyCodes;
